import React from "react";
import { Bars } from 'svg-loaders-react'

function ActionButton(props) {
  const { isLoading, ...rest } = props;

  let className="btn rounded p-3 w-full cursor-pointer text-center font-bold text-white bg-indigo-600 hover:bg-indigo-700";
  if(props.disabled) className="btn rounded p-3 w-full cursor-not-allowed text-center font-bold text-white bg-gray-500";

  return (
    <button
      disabled={isLoading}
      {...rest}
      className={className}
    >
      {isLoading ? (
        <Bars width="100" height="30" className="block m-auto"/>
      ) : (
        props.children
      )}
    </button>
  );
}

export default ActionButton;
